import { useState } from "react";
import {
  TextField,
  Card,
  Typography,
  MenuItem,
  Box,
  CircularProgress,
  InputAdornment,
} from "@mui/material";
import { styles } from "../theme/styles";
import { Creators } from "../store/ducks/users";
import { connect } from "react-redux";
import { CustomButton } from "../components/CustomButton";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Cliploader from "./Cliploader";
import Swal from "sweetalert2";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";

const PassForm = (props) => {
  const { userData } = props;
  const baseUrl = process.env.REACT_APP_API_PETCOZOO;
  const navigate = useNavigate();
  const { idOrder } = useParams();
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(new Date());
  const [fechaRecepcion, setFechaRecepcion] = useState("");
  const [tiendaDestino, setTiendaDestino] = useState("");
  const [noFactura, setNoFactura] = useState("");
  const [noempReporte, setNoempReporte] = useState("");
  const [tiendaResguardo, setTiendaResguardo] = useState("");
  const [existeEmpleado, setExisteEmpleado] = useState(null);
  const [validando, setValidando] = useState(false);
  const [nombreEmpleado, setNombreEmpleado] = useState("");
  const [empleadoValidado, setEmpleadoValidado] = useState(null);
  const [datosCargados, setDatosCargados] = useState(false);
  const [tiendasResguardo, setTiendasReguardo] = useState("");
  const [noempReporteError, setNoempReporteError] = useState(false);
  const [fechaRecepcionError, setFechaRecepcionError] = useState(false);
  const [noFacturaError, setNoFacturaError] = useState(false);
  const [tiendaDestinoError, setTiendaDestinoError] = useState(false);
  const [tiendaResguardoError, setTiendaResguardoError] = useState(false);
  const [proveedorText, setProveedorText] = useState("");
  const [proveedorId, setProveedorId] = useState("");
  const [ordenData, setOrdenData] = useState("");
  const [materialesOrden, setMaterialesOrden] = useState([]);
  const formattedDate = date.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const getOrdenInfo = async (numeroOrden) => {
    try {
      const tiendaUsuario = userData.idNumber;
      const { data } = await axios.post(
        `${baseUrl}/reporteRecepcion/getInfoOrderSap`,
        { idOrder: numeroOrden, tiendaLogueada: tiendaUsuario },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );
      setOrdenData(data);
      setMaterialesOrden(data.detalleOrden);
      setProveedorId(data.cabecero.idAcreedor);
      setProveedorText(data.cabecero.acreedor);
      setTiendaDestino(data.cabecero.idTienda);
    } catch (error) {
      console.log(
        "ocurrio un error al obtener informacion de la orden: ",
        error,
      );
    }
  };

  const validarEmpleado = async (numeroEmp = noempReporte) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_APP_EMPLEADOS}/${numeroEmp}`,
        {
          headers: {
            ApiKey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
            Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
          },
        },
      );
      if (!data?.nombreEmpleado || data.nombreEmpleado === "") {
        return { existe: false, nombre: "" };
      }
      return { existe: true, nombre: data.nombreEmpleado };
    } catch (error) {
      console.log("Error validando el empleado:", error);
      return { existe: false, nombre: "" };
    }
  };

  const handleEmpleadoBlur = async () => {
    if (!noempReporte || noempReporte.length < 5) return;
    if (existeEmpleado === true && empleadoValidado === noempReporte) return;

    setValidando(true);
    const resultado = await validarEmpleado(noempReporte);
    setValidando(false);
    setExisteEmpleado(resultado.existe);

    if (resultado.existe) {
      setNombreEmpleado(resultado.nombre);
      setNoempReporteError(false);
      setEmpleadoValidado(noempReporte);
    } else {
      setNombreEmpleado("");
      setNoempReporteError(true);
      await Swal.fire({
        icon: "error",
        title: "El empleado no existe",
        text: "No se ha encontrado información registrada del número ingresado.",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Corregir",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
      setNoempReporte("");
    }
  };

  const handleSiguiente = async (e) => {
    e.preventDefault();
    let empleadoOk = existeEmpleado === true && !!nombreEmpleado;
    let nombreFinal = nombreEmpleado;

    if (noempReporte && noempReporte.length >= 5 && !empleadoOk) {
      setValidando(true);
      const resultado = await validarEmpleado(noempReporte);
      setValidando(false);
      setExisteEmpleado(resultado.existe);

      if (!resultado.existe) {
        await Swal.fire({
          icon: "error",
          title: "El empleado no existe",
          text: "No se ha encontrado información registrada del número ingresado.",
          confirmButtonColor: "#00205B",
          confirmButtonText: "Corregir",
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        setNoempReporteError(true);
        setNoempReporte("");
        return;
      }

      nombreFinal = resultado.nombre;
      setNombreEmpleado(resultado.nombre);
      setEmpleadoValidado(noempReporte);
      setNoempReporteError(false);
      empleadoOk = true;
    }

    let faltanCampos = false;

    if (!fechaRecepcion) {
      setFechaRecepcionError(true);
      faltanCampos = true;
    }

    if (!tiendaDestino) {
      setTiendaDestinoError(true);
      faltanCampos = true;
    }

    if (!tiendaResguardo) {
      setTiendaResguardoError(true);
      faltanCampos = true;
    }

    if (!noFactura) {
      setNoFacturaError(true);
      faltanCampos = true;
    }

    if (!noempReporte || !empleadoOk) {
      setNoempReporteError(true);
      faltanCampos = true;
    }

    if (faltanCampos) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Por favor, ingresa todos los datos solicitados.",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
        allowOutsideClick: false,
      });
      return;
    }

    await crearRegistroMongo(nombreFinal);
  };

  useEffect(() => {
    const cargar = async () => {
      await getInfoOrderMongo();
      setDatosCargados(true);
    };
    cargar();
  }, []);

  useEffect(() => {
    if (!datosCargados) return;
    if (ordenData?.noemp) setNoempReporte(ordenData.noemp);
    if (ordenData?.nombreEmpleado) setNombreEmpleado(ordenData.nombreEmpleado);
    if (ordenData?.noemp && ordenData?.nombreEmpleado) setExisteEmpleado(true);
    console.log(ordenData);
  }, [ordenData, datosCargados]);

  const colorBorde =
    existeEmpleado === null ? "" : existeEmpleado ? "green" : "red";

  const getInfoOrderMongo = async () => {
    try {
      setLoading(true);
      const { data } = await axios.post(
        `${baseUrl}/reporteRecepcion/getInfoOrderMongo`,
        {
          idOrder: idOrder,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (data.data.noemp) {
        const partes = data.data.noemp.split(" - ");
        const numero = partes[0]?.trim() || "";
        const nombre = partes.slice(1).join(" - ").trim() || "";
        setNoempReporte(numero);
        if (nombre) setNombreEmpleado(nombre);
        if (numero && nombre) {
          setExisteEmpleado(true);
          setEmpleadoValidado(numero);
        }
      }

      setFechaRecepcion(data.data.fechaRecepcion);
      setNoFactura(data.data.factura);
      setTiendaDestino(data.data.tiendaDestino);
      setTiendaResguardo(data.data.tiendaResguardo);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(
        "ocurrio un error al obtener info de mongo de la orden",
        error,
      );
    }
  };

  const crearRegistroMongo = async (nombreParam) => {
    try {
      setLoading(true);
      const nombreUsado = nombreParam || nombreEmpleado;
      const empleadoCompleto = `${noempReporte} - ${nombreUsado}`;
      const data = await axios.post(
        `${baseUrl}/reporteRecepcion/crearOrdenMongo`,
        {
          idOrder: idOrder,
          factura: noFactura,
          fechaRecepcion: fechaRecepcion,
          tiendaDestino: tiendaDestino,
          tiendaResguardo: tiendaResguardo,
          proveedorText: proveedorText,
          proveedorId: proveedorId,
          noemp: empleadoCompleto,
          materialesOrden: materialesOrden,
        },
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
            apikey: `${process.env.REACT_APP_APIKEY}`,
            "Content-Type": "application/json",
          },
        },
      );
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Proceso guardado",
        text: "El proceso ha sido guardado hasta esto punto, despues podras continuar desde aqui",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(false);
          navigate(`/reporterecepcionExcel/${idOrder}`);
        } else {
          setLoading(false);
          return;
        }
      });
    } catch (error) {
      setLoading(false);
      console.log("error: ", error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar orden",
        text: "Inténtelo de nuevo",
        confirmButtonColor: "#00205B",
        confirmButtonText: "Aceptar",
      });
    }
  };

  const obtenerTienasResguardo = async () => {
    try {
      console.log("iniciando");
      const { data } = await axios.get(
        `${baseUrl}/tiendasReguardo/getAllTiendasResguardo`,
      );
      console.log("===TIENDAS RESGUARDO===", data);
      setTiendasReguardo(data.tiendas);
      console.log("terminando");
    } catch (error) {
      console.log("error en getTiendasResguardo", error);
    }
  };

  useEffect(() => {
    getOrdenInfo(idOrder);
    getInfoOrderMongo();
    obtenerTienasResguardo();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        justifyContent: "start",
        alignItems: "center",
        marginTop: "1rem",
      }}>
      <Cliploader loading={loading}></Cliploader>
      <Typography
        variant="h6"
        justifyContent="center"
        color="#00205b"
        style={styles.titleaux}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-around",
          }}>
          <span
            style={{
              fontWeight: "normal",
              fontSize: "80%",
              color: "black",
              fontWeight: "bold",
            }}>
            {" "}
            {formattedDate}
          </span>
          &nbsp;&nbsp; REPORTE DE RECEPCIÓN&nbsp;&nbsp;{" "}
          <span
            style={{
              fontWeight: "normal",
              fontSize: "80%",
              color: "black",
              fontWeight: "bold",
            }}>
            ORDEN &nbsp;
            {idOrder}
          </span>
        </div>
      </Typography>
      <Card
        sx={{
          width: "90%",
          height: "95%",
          border: "none",
        }}
        variant="outlined">
        <svg
          style={{
            cursor: "pointer",
            marginTop: "-5px",
            marginBottom: "-10px",
          }}
          onClick={(e) => {
            e.preventDefault();
            navigate("/reporterecepcion");
          }}
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#00205b"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round">
          <path d="M5 12l14 0" />
          <path d="M5 12l6 6" />
          <path d="M5 12l6 -6" />
        </svg>
        <p className="card-repo">
          <span style={{ color: "#C53030" }}>
            ⚠️ <strong>RECUERDA:</strong>{" "}
          </span>
          <span> El </span>
          <strong>reporte de recepción</strong> deberá generarse{" "}
          <strong style={{ color: "#004AAD" }}>de forma inmediata</strong> al
          momento de recibir el pedido.
          <br />
          <br />
          Posteriormente, será necesario{" "}
          <strong>dar seguimiento al mismo reporte</strong> dentro de un periodo
          máximo de <strong style={{ color: "#D97706" }}>24 horas</strong> para{" "}
          <strong>alimento vivo y congelado</strong>, y de{" "}
          <strong style={{ color: "#D97706" }}>48 horas</strong> para{" "}
          <strong>peces y animales</strong>, registrando las observaciones o
          actualizaciones correspondientes.
        </p>

        <div>
          <Card
            sx={{
              height: "250px",
              width: "100%",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 2,
              padding: 2,
              alignItems: "start",
              border: "none",
            }}
            variant="outlined">
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
              <label>Fecha de recepción:</label>
              <LocalizationProvider
                adapterLocale="es"
                dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={
                    fechaRecepcion ? dayjs(fechaRecepcion, "DD/MM/YYYY") : null
                  }
                  onChange={(newValue) => {
                    if (newValue) {
                      const formattedDate =
                        dayjs(newValue).format("DD/MM/YYYY");
                      setFechaRecepcion(formattedDate);
                      setFechaRecepcionError(false);
                    }
                  }}
                  slotProps={{
                    textField: {
                      size: "small",
                      error: fechaRecepcionError,
                    },
                    popper: {
                      sx: {
                        "& .MuiPaper-root": {
                          transition: "step-start",
                          transformOrigin: "top left",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
              <label>Tienda destino:</label>
              <TextField
                disabled={true}
                value={tiendaDestino}
                error={tiendaDestinoError}
                onChange={(e) => {
                  setTiendaDestino(e.target.value);
                  if (e.target.value.length > 0) {
                    setTiendaDestinoError(false);
                  }
                }}
                size="small"
              />
            </div>

            <div
              style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
              <label>No Factura:</label>
              <TextField
                value={noFactura}
                error={noFacturaError}
                onChange={(e) => {
                  setNoFactura(e.target.value);
                  if (e.target.value.length > 0) {
                    setNoFacturaError(false);
                  }
                }}
                size="small"
              />
            </div>

            {tiendasResguardo && tiendasResguardo.length > 0 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1px",
                }}>
                <label>Tienda resguardo:</label>
                <TextField
                  select
                  value={tiendaResguardo}
                  error={tiendaResguardoError}
                  onChange={(e) => {
                    setTiendaResguardo(e.target.value);
                    if (e.target.value.length > 0) {
                      setTiendaResguardoError(false);
                    }
                  }}
                  size="small">
                  {tiendasResguardo.map((tienda) => (
                    <MenuItem key={tienda._id} value={tienda.numeroTienda}>
                      {tienda.numeroTienda} - {tienda.nombreTienda}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            )}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
              <label>No empleado:</label>
              <TextField
                placeholder="Número de empleado"
                value={noempReporte} // SOLO el número es editable
                error={noempReporteError}
                helperText={
                  noempReporteError
                    ? "Campo obligatorio o empleado no válido"
                    : ""
                }
                onChange={(e) => {
                  const valor = e.target.value.trim();
                  if (/^\d*$/.test(valor) && valor.length <= 6) {
                    setNoempReporte(valor);
                    setNoempReporteError(false);
                    setExisteEmpleado(null);
                    setNombreEmpleado("");
                  }
                }}
                onBlur={handleEmpleadoBlur}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {existeEmpleado === true && noempReporte ? (
                        <span style={{ color: "green", fontSize: "18px" }}>
                          ✔
                        </span>
                      ) : existeEmpleado === false ? (
                        <span style={{ color: "red", fontSize: "18px" }}>
                          ✖
                        </span>
                      ) : null}
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      {validando ? (
                        <CircularProgress size={16} sx={{ color: "#00205B" }} />
                      ) : null}
                    </InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: noempReporteError ? "red" : colorBorde,
                    },
                    "&:hover fieldset": {
                      borderColor: noempReporteError ? "red" : colorBorde,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: noempReporteError ? "red" : colorBorde,
                    },
                  },
                }}
              />
            </div>
          </Card>

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: ".6rem",
            }}>
            {!loading ? (
              <CustomButton onClick={handleSiguiente} style={{ width: "20%" }}>
                SIGUIENTE
              </CustomButton>
            ) : (
              <></>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    menu: state.users.menu,
    userData: state.users.data,
    idNumber: state.users.idNumber,
    token: state.users.uid,
    loading: state.users.loading,
    message: state.config.message,
  };
};

const creators = {
  logout: Creators.logout,
  changePassword: Creators.changePassword,
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, creators)(PassForm);
